(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pd-item]').forEach(function (item) {
    var trigger = item.querySelector('[data-pd-trigger]');
    var panel = item.querySelector('[data-pd-panel]');

    if (item.classList.contains('is-open')) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
    }

    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');

      if (isOpen) {
        panel.style.maxHeight = null;
        item.classList.remove('is-open');
      } else {
        panel.style.maxHeight = panel.scrollHeight + 'px';
        item.classList.add('is-open');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-vs-track]').forEach(function (track) {
    var items = Array.from(track.querySelectorAll('[data-vs-item]'));
    var activeItem = null;
    var tickingScroll = false;

    function deactivate(item) {
      var video = item.querySelector('video');
      if (video) {
        video.pause();
        video.muted = true;
      }
      item.classList.remove('is-active');
      item.classList.remove('is-unmuted');
    }

    function activate(item) {
      if (!item || item === activeItem) return;

      items.forEach(function (other) {
        if (other !== item) deactivate(other);
      });

      var video = item.querySelector('video');
      if (video) {
        video.play().catch(function () {
          // Autoplay met geluid kan geblokkeerd worden door de browser; blijft gewoon gemute afspelen
        });
      }
      item.classList.add('is-active');
      activeItem = item;
    }

    function stopAll() {
      items.forEach(function (item) {
        deactivate(item);
      });
      activeItem = null;
    }

    // Bepaalt welke video het dichtst bij het midden van de rij staat
    function findCenteredItem() {
      var trackRect = track.getBoundingClientRect();
      var centerX = trackRect.left + trackRect.width / 2;
      var closest = null;
      var closestDistance = Infinity;

      items.forEach(function (item) {
        var rect = item.getBoundingClientRect();
        var itemCenter = rect.left + rect.width / 2;
        var distance = Math.abs(itemCenter - centerX);
        if (distance < closestDistance) {
          closestDistance = distance;
          closest = item;
        }
      });

      return closest;
    }

    function updateFromScroll() {
      tickingScroll = false;
      var centered = findCenteredItem();
      if (centered) activate(centered);
    }

    track.addEventListener('scroll', function () {
      if (!tickingScroll) {
        tickingScroll = true;
        requestAnimationFrame(updateFromScroll);
      }
    });

    // Start pas met afspelen zodra de sectie echt in beeld komt, en stopt weer zodra hij
    // grotendeels uit beeld scrolt. Zo wordt er tijdens het laden van de pagina niets opgehaald.
    var viewportObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.intersectionRatio < 0.3) {
            stopAll();
          } else if (!activeItem) {
            var centered = findCenteredItem() || items[0];
            if (centered) activate(centered);
          }
        });
      },
      { root: null, threshold: [0, 0.3, 1] }
    );
    viewportObserver.observe(track);

    items.forEach(function (item) {
      item.addEventListener('click', function (e) {
        if (e.target.closest('[data-vs-mute]')) return;

        activate(item);
        item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });

      var muteBtn = item.querySelector('[data-vs-mute]');
      var video = item.querySelector('video');

      if (muteBtn && video) {
        muteBtn.addEventListener('click', function (e) {
          e.stopPropagation();

          // Klikken op het geluidsicoon maakt deze video ook meteen de actieve/afspelende
          if (item !== activeItem) {
            activate(item);
            item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }

          video.muted = !video.muted;
          item.classList.toggle('is-unmuted', !video.muted);
        });
      }
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAll();
    });

    window.addEventListener('pagehide', stopAll);
  });

  } catch(e) { console.error(e); }
})();
})();
